import React, {useContext, useEffect, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import getStep from '../../../helpers/getStep';


const OccupationActivity = ({ _step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const data = getDataFromContext(step_ID)
    
    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [nextTick, setNextTick] = useState(false)



    const getInputValue = (name, value) => {
      if (value !== "") {
               setInputData({
            ...inputData,
            [name] : value
               })
        }
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            setDataToContext(step_ID, step_URL, step_ID, inputData[step_ID])
            setNextTick(true)
        }
    }, [inputData])

    useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            action()
        }
    }, [nextTick])

    const [savedData, setSavedData] = useState({})
    useEffect(() => {
        const asyncfunc = async () => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "2",
stepName: "financial info:profession",
eventAction: "stepStart",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }
            const serverData = await getStep(['occupation_activity'])
            setSavedData({occupation_activity: Number(serverData.occupation_activity)})
        }
        asyncfunc()
     }, [])


    
    const optionsList = [
        {value:1, label:t('financial_infos.financial_info_profession.employee')},
        { value: 2, label: t('financial_infos.financial_info_profession.worker') },
        {value:3, label:t('financial_infos.financial_info_profession.government_worker')},
        { value: 4, label: t('financial_infos.financial_info_profession.freelancer')},
        {value:5, label:t('financial_infos.financial_info_profession.administrator')},
        { value: 6, label: t('financial_infos.financial_info_profession.student')},
        {value:7, label:t('financial_infos.financial_info_profession.no_occupaion')},
        {value:8, label:t('financial_infos.financial_info_profession.annuitant')},
        {value:9, label:t('financial_infos.financial_info_profession.retired')},
    ]

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{ t('financial_infos.financial_info_profession.title') }</h3>
                </BaseParagraph>

                <InputField type={"select"} name={"occupation_activity"}
                            options={optionsList}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && savedData[step_ID]}


                />
            </StepsLoader>
        </>
    )
}

OccupationActivity.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}




export default OccupationActivity